import * as React from "react";
import clsx from "clsx";
import { Label } from "../Label/Label";
import { FormInputErrorMessage } from "../FormInputErrorMessage/FormInputErrorMessage";

export interface TextFieldProps extends React.ComponentProps<"input"> {
  label: string;
  id: string;
  errorMessage?: string;
}

function TextFieldInner(
  props: TextFieldProps,
  forwardedRef: React.ForwardedRef<HTMLInputElement>
) {
  const { label, id, errorMessage, type = "text", ...rest } = props;
  return (
    <div>
      <Label htmlFor={id}>{label}</Label>

      <input
        id={id}
        type={type}
        ref={forwardedRef}
        className={`block w-full p-4 text-base rounded-lg bg-gray-100 border ${
          errorMessage
            ? "border-red-500 focus:ring-red-500 focus:border-red-500"
            : "border-gray-300 focus:ring-purple-500 focus:border-purple-500"
        } placeholder-gray-400 shadow-sm focus:outline-none`}
        // className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500"
        aria-invalid={!!errorMessage}
        aria-describedby={clsx({
          [`${id}-error`]: !!errorMessage,
        })}
        {...rest}
      />

      <FormInputErrorMessage id={`${id}-error`}>
        {errorMessage}
      </FormInputErrorMessage>
    </div>
  );
}

const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  TextFieldInner
);

TextField.displayName = "TextField";

export { TextField };
